import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';

export default function useActiveEvents() {
  const currentUser = useUser();

  return useConnect('event.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });
}
